import type { PropsWithChildren } from 'react';
import type { TableInfiniteDataSource } from './utils';
import { FiltersProvider } from './filters/FiltersProvider';
import type { AnyColumnDef } from './utils/Any';
import { useLoadSavedView } from './utils/useLoadSavedView';
import { TableDataProvider } from './utils';
import { CircularProgress } from '@nexelem/components';

type NexelemTableProps = {
  dataSource: TableInfiniteDataSource;
  columns: AnyColumnDef[];
};

const NexelemTableView = ({ children }: PropsWithChildren) => {
  const { isLoading } = useLoadSavedView();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <CircularProgress size={100} />
      </div>
    );
  }

  return (
    <FiltersProvider>
      <div className="box-border flex h-full flex-col">{children}</div>
    </FiltersProvider>
  );
};

export const NexelemTableRoot = ({ dataSource, columns, children }: PropsWithChildren<NexelemTableProps>) => (
  <TableDataProvider columns={columns} dataSource={dataSource}>
    <NexelemTableView>{children}</NexelemTableView>
  </TableDataProvider>
);
